import React from 'react';

import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';
import { FolderIcon } from '@/shared/assets/icons/folder-icon';
import { TenantIcon } from '@/shared/assets/icons/tenant-icon';
import { UserIcon } from '@/shared/assets/icons/user-icon';
import { UserRoleIcon } from '@/shared/assets/icons/user-role-icon';
import { TResourceElements } from '@/shared/features/groups/context/groups-config-context.types';
import { TPermissionAction } from '@/shared/features/permissions/actions';

export const useBackofficeResourceElements = (): TResourceElements => {
  const getIcon = (typename: string, iconProps?: TBaseIcon) => {
    switch (typename) {
      case 'SuperUserResponseType':
        return <UserIcon {...iconProps} />;
      case 'SuperUserRoleResponseType':
        return <UserRoleIcon {...iconProps} />;
      case 'TenantResponseType':
        return <TenantIcon {...iconProps} />;
      default:
        return <FolderIcon {...iconProps} />;
    }
  };

  const getUpdatePermissionAction = (
    typename: string,
  ): TPermissionAction | undefined => {
    switch (typename) {
      case 'SuperUserResponseType':
        return 'backofficeUser:updateUser';
      case 'SuperUserRoleResponseType':
        return 'backofficeUserRole:updateUserRole';
      case 'BackofficeResourceGroupResponseType':
      case 'ResourceGroupResponseType':
        return 'backofficeGroup:updateGroup';
      case 'TenantResponseType':
        return 'backofficeTenant:updateTenant';
      default:
        return undefined;
    }
  };

  return { getIcon, getUpdatePermissionAction };
};
